import React from "react";

interface TopLeftCornerProps {
  className?: string;
}

const TopLeftCorner: React.FC<TopLeftCornerProps> = ({ className }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.5 0.5C8.76522 0.5 9.06246 0.562464 9.25 0.75C9.43754 0.937536 9.5 1.23478 9.5 1.5M9.5 8.5C9.5 8.76522 9.43754 9.06246 9.25 9.25C9.06246 9.43754 8.76522 9.5 8.5 9.5M1.5 9.5C1.23478 9.5 0.937536 9.43754 0.75 9.25C0.562464 9.06246 0.5 8.76522 0.5 8.5M4 0.5C4 0.5 3.94526 0.5 3.75 0.5C1.75 0.5 0.5 2 0.5 4M3.5 9.5H4M6 0.5H6.5M6 9.5H6.5M9.5 3.5V4M0.5 6V6.5M9.5 6V6.5"
        stroke="#475569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TopLeftCorner;
